/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useSelector } from 'react-redux';

import { useFacilityAlerts } from 'sarsaparilla';

import { FacilityInfoTab } from '../../components/FacilityPage/FacilityInfoTab.jsx';

export function FacilityInfoTabContainer() {
    const alerts = useFacilityAlerts();
    const facilityData = useSelector((state) => state.timedEntry.facility);

    const {
        facility_name: facilityName,
        facility_directions: directionsHtml,
        facility_phone: phone,
    } = facilityData;

    const notes = facilityData?.notes || [];
    const address = facilityData?.asset_addresses?.[0] || {};

    const needToKnowItems = notes.map((item) => ({
        title: item.title,
        description: item.description,
        priority: item.importance_level === 1 ? 'low' : 'high',
    }));

    return (
        <FacilityInfoTab
            alerts={alerts}
            needToKnowItems={needToKnowItems}
            directionsHtml={directionsHtml}
            facilityName={facilityName}
            address={address}
            phone={phone}
        />
    );
}
